export default __webpack_public_path__ + "static/media/warning--double-curve-first-left--g1.6eb7ea5d.png";